import { IPersonaProps, PersonaSize, PersonaPresence } from '@fluentui/react';
import { TimeSearchRow } from '../../../../../api/generated/data-contracts';

export const mapTaskToPersona = (task: TimeSearchRow): IPersonaProps => {
    return {
        imageInitials: (task.taskName?.substring(0, 1) || '') + (task.projectName?.substring(0, 1) || ''),
        text: task.taskName,
        secondaryText: task.projectName,
        showSecondaryText: true,
        size: PersonaSize.size48,
        presence: PersonaPresence.none,
        imageAlt: task.taskName + ', ' + task.projectName,
        itemID: task.taskId,
    } as IPersonaProps;
};
